<template>
  <dropdown
    :force-visibility="showDropdown"
    :title="action"
    class="item-export-picker"
    placement="bottom"
    popper-min-width-size="medium"
  >
    <el-tooltip placement="top">
      <template #content>
        <div>{{ action }}</div>
      </template>
      <i class="ddi ddi-download" />
    </el-tooltip>
    <template #content>
      <div>
        <h5 v-if="entityType === EEntities.PROJECTS">
          Export/Import Tasks
        </h5>
        <h5 v-else>
          Export {{ itemTypeNamePlural }} as CSV
        </h5>
        <p v-if="!hasItems">
          There are no {{ itemTypeNamePlural }} to export.
        </p>
        <ul v-else>
          <li><a :href="getExportLink(false)" @click="closeDropdown"><i class="ddi ddi-download" /><span>{{ itemCountText }}</span></a></li>
          <li><a :href="getExportLink(true)" @click="closeDropdown"><i class="ddi ddi-download" /><span>{{ itemCountText }} &amp; history</span></a></li>
        </ul>
        <ul v-if="entityType === EEntities.PROJECTS">
          <li><a role="button" @click="$emit('import-clicked')"><i class="ddi ddi-move-up" /> Import Tasks from CSV</a></li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import config from '@/config'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default defineComponent({
  name: 'ItemExportPicker',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    totalItemCount: {
      type: Number,
      default: null,
    },
  },

  emits: ['import-clicked'],

  data() {
    return {
      showDropdown: false,
      EEntities,
    }
  },

  computed: {
    action(): string {
      if (this.entityType === EEntities.PROJECTS) {
        return 'Export/Import Tasks'
      }
      return `Export ${this.itemTypeNamePlural}`
    },
    hasItems(): boolean {
      return this.totalItemCount && this.totalItemCount !== 0
    },
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
    itemTypeNamePlural(): string {
      return TextAssistant.itemPluralName(this.entityType)
    },
    itemTypeNameSingular(): string {
      return TextAssistant.itemSingularName(this.entityType)
    },
    itemCountText(): string {
      if (this.totalItemCount === 1) {
        return `One ${this.itemTypeNameSingular.toLowerCase()}`
      } else {
        return `All ${
          this.totalItemCount
        } ${this.itemTypeNamePlural.toLowerCase()}`
      }
    },
  },

  methods: {
    closeDropdown() {
      this.$messaging.showSuccess('Your export is downloading.')
      this.showDropdown = true
      this.$nextTick(() => {
        this.showDropdown = false
      })
    },
    getExportLink(includeHistory: boolean): string {
      const root =
        config.apiUrl +
        `${this.accountID}/${TextAssistant.itemPluralName(
          this.entityType,
        )}/search/export?`

      const params = Object.keys(this.$route.query)
        .map(key => key + '=' + encodeURIComponent(String(this.$route.query[key])))
        .join('&')

      let entityParam = `&internal_project_ids=${this.entityId}`

      if (this.entityType === EEntities.MAILBOXES) {
        entityParam = `&mailbox_ids=${this.entityId}`
      }
      return (
        root +
        params +
        entityParam +
        '&file_type=csv&include_history=' +
        String(includeHistory)
      )
    },
  },
})
</script>
<style lang="scss">
.item-export-picker {
  p {
    @include lettering--p-sm;
    margin: 4px;
  }

  .dropdown__trigger {
    .ddi-download {
      @include clickable-gray-color-states;
    }
  }
}
</style>
